import React, { useEffect, useState } from 'react';
import { Button } from '@material-ui/core';
import { getCMSPagesApi, updateCMSPageApi } from 'api';
import JoditEditor from 'jodit-react';
import { useDispatch, useSelector } from 'react-redux';
import { updateRewardPage } from 'redux/actions/cms_pages';
import { BackdropCircular } from 'components';


const config = {
  'showXPathInStatusbar': false,
  'spellcheck': false,
  'askBeforePasteHTML': false,
  'askBeforePasteFromWord': false,
  'disablePlugins': 'table,preview,table-keyboard-navigation,image,media,video,file,add-new-line,about,class-span,focus,delete,wrap-text-nodes,copy-format,clipboard,color,drag-and-drop,drag-and-drop-element,error-messages,font,format-block,fullsize,hotkeys,iframe,indent,hr,inline-popup,justify,limit,link,mobile,ordered-list,placeholder,redo-undo,resizer,search,select,size,resize-handler,source,stat,sticky,symbols,tooltip,xpath,image-properties,image-processor',
  'buttons': 'bold,italic,underline,ul,ol'
};

const RewardInfoEditor = ({ setOpenRewardInfoEditor }) => {
  const dispatch = useDispatch();
  const { cmsPages, loadingUpdateCmsPages, loadingCmsPages } = useSelector((state: IReduxState) => state.cms_pages);
  const [editorContent, setEditorContent] = useState('');
  const [blurredContent, setBlurredContent] = useState('');
  const rewardProgramPage = !!cmsPages.length && cmsPages.find((page) => page.identifier === 'rewardpointsinfo' || page.identifier === 'myrewards');

  useEffect(() => {
    if (!cmsPages.length) {
      getCMSPagesApi({dispatch});
    } else if (rewardProgramPage) {
      const contentWithPlaceholders = rewardProgramPage.content
        .replace(/{{store direct_url="([^"]+)"}}/g, '[STORE_DIRECT_URL=$1]');
      setEditorContent(contentWithPlaceholders);
    }
  }, [cmsPages]);

  const handleSave = () => {
    if (rewardProgramPage && blurredContent) {
      const updatedPage = { ...rewardProgramPage, content: blurredContent };

      dispatch(updateRewardPage(updatedPage));
      updateCMSPageApi({ dispatch, pageData: updatedPage });
    }

    setOpenRewardInfoEditor(false);
  };

  const handleBlur = (newContent) => {
    const contentWithPlaceholders = newContent
      .replace(/{{store direct_url="([^"]+)"}}/g, '[STORE_DIRECT_URL=$1]')
      .replace(/style="(.*?)"/gm, '');

    const contentRestored = contentWithPlaceholders
      .replace(/\[STORE_DIRECT_URL=([^\]]+)\]/g, '{{store direct_url="$1"}}');

    setBlurredContent(contentRestored);
    setEditorContent(contentRestored);
  };

  return (
    <div>
      <Button
        color="primary"
        variant="contained"
        className="mb-6 mr-4"
        onClick={handleSave}
      >
        Save Changes
      </Button>
      <Button
        variant="contained"
        className="mb-6"
        onClick={() => setOpenRewardInfoEditor(false)}
      >
        Cancel
      </Button>
      {rewardProgramPage?.content ?
        <JoditEditor
          value={editorContent}
          config={config}
          onBlur={handleBlur}
          onChange={setEditorContent}
        />
        : <div className="text-muted">No such page on your store</div>
      }
      <BackdropCircular loading={loadingUpdateCmsPages || loadingCmsPages} />
    </div>
  );
};

export default RewardInfoEditor;
